<template>
  <div v-if="discountDetails !== null">
    <div class="row">
      <div class="col-md-12">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div style="margin-bottom: 10px">
          <h4 style="margin: 0px; padding: 0px">
            {{ discountDetails.code }}
            <span style="font-size: 12px"
              >created {{ discountDetails.dateAddedString }}</span
            >
          </h4>

          <!-- <p style="padding: 0px; margin: 0px">
            <a
              :href="discountDetails.trackingUrl"
              target="_blank"
              class="detail-text"
              >{{ discountDetails.trackingUrl }}</a
            >
          </p>
          <p style="padding: 0px; margin: 0px">
            <a
              :href="'https://convo.is/' + discountDetails.shortLink.shortcode"
              target="_blank"
              >convo.is/{{ discountDetails.shortLink.shortcode }}</a
            >
          </p> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-lg-3 col-md-6 col-sm-6"
        v-if="discountAnalyticsSummary !== null"
      >
        <stats-card
          type="primary"
          icon="fas fa-mouse"
          small-title="Sales"
          :title="'$' + discountAnalyticsSummary.totalSales"
          v-if="typeof discountAnalyticsSummary !== 'undefined'"
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
        <stats-card
          type="primary"
          icon="fas fa-mouse"
          small-title="Sales"
          :title="'$0'"
          v-else
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
      </div>
      <div
        class="col-lg-3 col-md-6 col-sm-6"
        v-if="discountAnalyticsSummary !== null"
      >
        <stats-card
          type="primary"
          icon="fas fa-globe"
          small-title="Orders"
          :title="String(discountAnalyticsSummary.orderCount)"
          v-if="typeof discountAnalyticsSummary !== 'undefined'"
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
        <stats-card
          type="primary"
          icon="fas fa-globe"
          small-title="Orders"
          :title="'0'"
          v-else
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import _ from "underscore";
import { mapGetters, mapActions } from "vuex";
import timeVars from "@/config/timeVars";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import LineChart from "@/components/UIComponents/Charts/LineChart";
import BarChart from "@/components/UIComponents/Charts/BarChart";
import PieChart from "@/components/UIComponents/Charts/PieChart";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import { VueDatamaps } from "vue-datamaps";
import VueApexCharts from "vue-apexcharts";
import { GChart } from "vue-google-charts";
import store from "@/store/index.js";
import Datepicker from "vuejs-datepicker";
import numeral from "numeral";

import {
  clientProfileReadApi,
  userLoadApi,
  fbGraphInstagramCheck,
  userRelatedProfilesApi,
  discountCodeReadApi,
  influencerCandidateReadApi,
  shopifyOrderAnalyticsApi,
} from "@/config/appSettings";
import Axios from "axios";
const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10,
};

export default {
  name: "InstagramAnalytics",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    clientDetails: null,
    auth: null,
    getTime: null,

    loadingOverlay: false,
    loadingOverlayText: null,
    instagramLinked: null,

    analyticsData: null,
    discountDetails: null,
    discountAnalytics: null,
    discountAnalyticsSummary: null,
    startDate: null,
    endDate: null,
  }),
  components: {
    ChartCard,
    LineChart,
    BarChart,
    StatsCard,
    Datepicker,
  },
  created: function () {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
    async checkNoAuthProfiles() {
      try {
        if (this.isTeam == true) {
          //console.log("ACTIVE INSTAGRAM:", this.activeInstagram);
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${this.activeInstagram}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
          return;
        }
        // console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (
          this.relatedProfileStore !== null &&
          typeof this.relatedProfileStore !== "undefined"
        ) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          // console.log("RESETTING PROFILES:", this.relatedProfiles);
          this.relatedProfileList = this.relatedProfiles.map((x) => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async loadDiscountDetails() {
      try {
        let discountDetailsUrl = `${discountCodeReadApi}/?usertoken=${this.auth}&discount=${this.$route.params.discountId}`;
        //console.log("DISCOUNT DETAILS ANALYTICS URL:", discountDetailsUrl);
        let discountDetailsResponse = await axios.get(discountDetailsUrl);
        //console.log("DISCOUNT DETAILS RESPONSE:", discountDetailsResponse.data);
        if (discountDetailsResponse.data.success == true) {
          this.discountDetails = discountDetailsResponse.data.result;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadInfluencer() {
      try {
        //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
        let influencerLoadResponse = await axios.get(
          `${influencerCandidateReadApi}/?usertoken=${this.auth}&influencer=${this.discountDetails.influencerId}`
        );

        //console.log("LOAD RESPONSE:", influencerLoadResponse.data);

        if (influencerLoadResponse.data.success === true) {
          this.influencerDetails = influencerLoadResponse.data.result;
          //console.log("INFLUENCER DETAILS", this.influencerDetails);

          return;
        }
        this.loadingText = "There was an error loading. Refresh page.";
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async loadShopifyOrderStats() {
      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      try {
        let orderAnalyticsUrl = `${shopifyOrderAnalyticsApi}/?usertoken=${this.auth}&shop=${this.discountDetails.store}`;

        if (typeof this.discountDetails.code !== "undefined") {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&code=${this.discountDetails.code}`;

          //console.log("SENDING ORDER ANALYTICS URL:", orderAnalyticsUrl);

          let discountAnalyticsResponse = await axios.get(orderAnalyticsUrl);
          //console.log("DISCOUNT ANALYTICS:", discountAnalyticsResponse.data);
          if (discountAnalyticsResponse.data.success == true) {
            this.discountAnalytics = discountAnalyticsResponse.data.result;
            this.discountAnalyticsSummary =
              discountAnalyticsResponse.data.summary;
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async formatDate(dateInput) {
      let thisDate = moment(dateInput).format("yyyy-MM-DD");
      //console.log("THIS DATE:", thisDate);
    },
    async resetDates() {
      try {
        //console.log("START DATE", this.pickerStart);
        let startDateString = new Date(this.pickerStart); // Your timezone!
        this.startDate = startDateString.getTime() / 1000;
        //console.log("START TIMESTAMP: ", this.startDate);
        //console.log("END DATE", this.pickerEnd);
        let endDateString = new Date(this.pickerEnd); // Your timezone!
        this.endDate = endDateString.getTime() / 1000;
        //console.log("END TIMESTAMP: ", this.endDate);
        if (this.startDate < this.endDate) {
          let startDateUrl = moment
            .unix(this.startDate)
            .startOf("day")
            .format("YYYY-MM-DD");
          let endDateUrl = moment
            .unix(this.endDate)
            .endOf("day")
            .format("YYYY-MM-DD");
          this.analyticsData = null;
          await this.loadShopifyOrderStats();

          if (
            startDateUrl == this.$route.query.start &&
            endDateUrl == this.$route.query.end
          ) {
            return;
          }

          this.$router.push(
            `/shopify/orders/${this.$route.params.shop}/?start=${startDateUrl}&end=${endDateUrl}`
          );
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async loadPageContent() {
      this.getTime = await timeVars.timeInfo();
      //console.log("UTC TIME:", this.getTime.utcTime);

      this.endDate =
        moment.unix(this.getTime.utcTime).startOf("day").utc() / 1000;
      this.startDate =
        moment.unix(this.endDate).utc().subtract(1, "month") / 1000;

      //console.log("GENERIC START DATE:", this.startDate);
      //console.log("GENERIC END DATE:", this.endDate);

      this.pickerStart = new Date(this.startDate * 1000);

      if (this.isClient == true) {
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }
      if (this.isInfluencer == true) {
        if (this.relatedProfiles !== null) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }

      if (this.isTeam == true) {
        this.activeInstagram = this.$route.params.instagram;
      }

      await this.loadDiscountDetails();
      if (this.discountDetails !== null) {
        if (typeof this.discountDetails.influencerId !== "undefined") {
          this.loadInfluencer();
        }
        if (typeof this.discountDetails.store !== "undefined") {
          if (typeof this.discountDetails.code !== "undefined") {
            this.loadShopifyOrderStats();
          }
        }
      }

      this.loadingOverlay = false;
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  },
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>